<template>
    <div class="row p-2 widget my-2">
        <div class="col-4">
            <img
                class="img-fluid rounded-circle mr-2 profile-image"
                :src="
                    patient.profile_photo_url
                        ? patient.profile_photo_url
                        : '../../../images/default_patient.jpeg'
                "
            />
        </div>
        <div class="col-8 d-flex flex-column justify-content-center">
            <p class="mb-0 text-uppercase font-weight-bold">
                {{ patient.first_name }} {{ patient.last_name }}
            </p>
            <p class="mb-0">{{ patient.diagnose }}</p>
            <p class="mb-0">
                {{ moment().diff(patient.dob, "years") }} years old ({{
                    moment().diff(patient.dob, "months")
                }}
                months)
            </p>
        </div>
    </div>
</template>

<script>
export default {
    name: "PatientOverview",
    props: ["patient"],
};
</script>

<style scoped lang="scss">
.widget {
    background-color: #fff;
}
.profile-image {
    min-width: 7rem;
    max-width: 7rem;
    min-height: 7rem;
    max-height: 7rem;
}
</style>
